<div class="modal-header bg-light">
    <h5 class="modal-title">{{ 'translation.update.modal.title' | translate }}</h5>
    <button type="button" class="close" (click)="activeModal.dismiss()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body bg-white">
    <div class="title">
        {{ 'translation.update.modal.entityType.title' | translate }} :
        <span class="text-primary">{{ 'translation.entityType.' + entityType + '.label' | translate }}</span>
    </div>

    <div class="ref-value">
        {{ 'translation.update.modal.refValue.title' | translate }} :
        <span class="text-primary">{{ refValue }}</span>
    </div>

    <div class="lang-list">
        <div class="title">
            {{ 'translation.languages.title' | translate }}
        </div>
        <div class="row">
            <div class="col-6" *ngFor="let trans of translations">
                <div class="form-group">

                    <label class="col-form-label text-left">
                        <img [src]="trans.flag" alt="">&nbsp;
                        {{ 'translate.lang.' + trans.codeLang + '.label' | translate }}
                    </label>

                    <input *ngIf="!multiline" class="form-control" type="text" [(ngModel)]="trans.value">
                    <textarea *ngIf="multiline" class="form-control" [(ngModel)]="trans.value" rows="2"></textarea>

                    <div class="btn-trad" (click)="getTrad(trans)">
                        <fa-icon [icon]="['fas', 'globe']"></fa-icon>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>
<div class="modal-footer bg-light">
    <button ngbAutoFocus type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">{{ 'button.action.cancel.label' |
        translate }}</button>
    <button type="button" class="btn btn-primary" (click)="saveTranslations()">{{ 'button.action.valid.label' | translate }}</button>
</div>